import ScreenBanner from "../../components/ScreenBanner";
import PermissionGuard from "../../components/PermissionGuard";
import { Container, Grid } from "@mui/material";
import { useMemo } from "react";
import { TItemAcaoRapida } from "../../components/ListaAcoesRapidas";
import RefreshIcon from "@mui/icons-material/RefreshOutlined";
import ListOutlinedIcon from "@mui/icons-material/ListOutlined";
import ListaAcoesRapidas from "../../components/ListaAcoesRapidas";
import { usePermission } from "../../components/PermissionGuard";

export function Fabrica(){
  const solicitarInsumo = usePermission('fabrica.solicitar-insumos');
  const listarTodos = usePermission('fabrica.listar-todos');

  const listaAcoesRapidas: Array<TItemAcaoRapida> = useMemo(() => [
    {
        label: "Solicitar insumo",
        icon: <RefreshIcon color="primary" />,
        action: () => {},
        havePermission: solicitarInsumo
    },
    {
        label: "Listar todas",
        icon: <ListOutlinedIcon color="primary" />,
        action: () => {},
        havePermission: listarTodos
    },
], [solicitarInsumo, listarTodos])
  
  return (
    <>
    <ScreenBanner title="Fabrica" />
    <PermissionGuard permissionId="fabrica.dashboard">
                    <Container>
                        <Grid container spacing={2} mt={2}>
                            <Grid size={{ xs: 12, md: 4 }}>
                                <ListaAcoesRapidas
                                    items={listaAcoesRapidas}
                                />
                            </Grid>
                        </Grid>
                    </Container>
                </PermissionGuard>
    
    </>
  )
}